// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2mbjh","paramInput":"JobSimulator_paramInput__1lT4o","input":"JobSimulator_input__3fTaM"};